"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = AllocationForm;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _material = require("@mui/material");
var _api = require("@focaltec-suite/api");
var _commons = require("@focaltec-suite/commons");
var _core = require("@focaltec-suite/core");
var _AllocationPartForm = _interopRequireDefault(require("./AllocationPartForm"));
var _deepEqual = _interopRequireDefault(require("deep-equal"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
function AllocationForm(_ref) {
  var _this = this;
  var match = _ref.match;
  var _a, _b;
  var history = (0, _reactRouterDom.useHistory)();
  var context = (0, _react.useContext)(_core.AppContext);
  var access = context.access;
  var feedbackContext = (0, _react.useContext)(_commons.FeedbackContext);
  var location = (0, _reactRouterDom.useLocation)();
  var query = new URLSearchParams(location.search);
  var tenantId = (_b = (_a = access === null || access === void 0 ? void 0 : access.tenant) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '-';
  var allocationId = match.params.allocationId;
  var allocationConfigurationId = query.get('allocationConfigurationId');
  var mine = (0, _react.useMemo)(function () {
    return location.pathname.indexOf('mine') >= 0;
  }, [location]);
  var _useValidatedForm = (0, _commons.useValidatedForm)(),
    isValid = _useValidatedForm.isValid,
    register = _useValidatedForm.register,
    bind = _useValidatedForm.bind,
    isDirty = _useValidatedForm.isDirty,
    setPristine = _useValidatedForm.setPristine;
  var _useCalculatedId = (0, _commons.useCalculatedId)(allocationId),
    initialId = _useCalculatedId.initialId,
    validators = _useCalculatedId.validators,
    hasChangedName = _useCalculatedId.hasChangedName,
    nameValidators = _useCalculatedId.nameValidators;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    allocation = _useState2[0],
    setAllocation = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    parts = _useState4[0],
    setParts = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    allocationConfigurationsOptions = _useState6[0],
    setAllocationConfigurationsOptions = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    popup = _useState8[0],
    setPopup = _useState8[1];
  var _useState9 = (0, _react.useState)(),
    _useState10 = _slicedToArray(_useState9, 2),
    allocationConfiguration = _useState10[0],
    setAllocationConfiguration = _useState10[1];
  var _useState11 = (0, _react.useState)([]),
    _useState12 = _slicedToArray(_useState11, 2),
    allocationConfigurations = _useState12[0],
    setAllocationConfigurations = _useState12[1];
  var _useState13 = (0, _react.useState)([]),
    _useState14 = _slicedToArray(_useState13, 2),
    costCenters = _useState14[0],
    setCostCenters = _useState14[1];
  var _useState15 = (0, _react.useState)([]),
    _useState16 = _slicedToArray(_useState15, 2),
    catalogs = _useState16[0],
    setCatalogs = _useState16[1];
  var _useState17 = (0, _react.useState)(100),
    _useState18 = _slicedToArray(_useState17, 2),
    currentPercentage = _useState18[0],
    setCurrentPercentage = _useState18[1];
  var _useState19 = (0, _react.useState)(),
    _useState20 = _slicedToArray(_useState19, 2),
    part = _useState20[0],
    setPart = _useState20[1];
  var _useState21 = (0, _react.useState)(-1),
    _useState22 = _slicedToArray(_useState21, 2),
    index = _useState22[0],
    setIndex = _useState22[1];
  var disabled = (0, _react.useMemo)(function () {
    return (allocation === null || allocation === void 0 ? void 0 : allocation.status) === 'INACTIVE';
  }, [allocation]);
  var retrievePromise = (0, _react.useCallback)(function () {
    if (allocationId) {
      return (0, _api.getAllocation)(tenantId, allocationId, {
        access: access
      });
    }
    return (0, _api.emptyPromise)();
  }, [tenantId, allocationId, access]);
  var allocationConfigurationsPromise = (0, _react.useCallback)(function () {
    return (0, _api.listAllocationConfigurations)(tenantId, {
      status: allocationId ? undefined : 'ACTIVE'
    }, {
      access: access
    });
  }, [tenantId, allocationId, access]);
  var costCentersPromise = (0, _react.useCallback)(function () {
    return (0, _api.listCostCenters)(tenantId, (0, _api.emptyParams)(), {
      access: access
    });
  }, [tenantId, access]);
  var catalogsPromise = (0, _react.useCallback)(function () {
    return (0, _api.listCatalogs)(tenantId, (0, _api.emptyParams)(), {
      access: access
    });
  }, [tenantId, access]);
  var fetchData = (0, _react.useCallback)(function () {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _yield$Promise$all, _yield$Promise$all2, allocation, allocationConfigurations, costCenters, catalogs;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Promise.all([retrievePromise(), allocationConfigurationsPromise(), costCentersPromise(), catalogsPromise()]);
          case 2:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 4);
            allocation = _yield$Promise$all2[0];
            allocationConfigurations = _yield$Promise$all2[1];
            costCenters = _yield$Promise$all2[2];
            catalogs = _yield$Promise$all2[3];
            return _context.abrupt("return", [allocation, allocationConfigurations, costCenters, catalogs]);
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  }, [retrievePromise, allocationConfigurationsPromise, costCentersPromise, catalogsPromise]);
  var setData = function setData(_ref2) {
    var _ref3 = _slicedToArray(_ref2, 4),
      allocation = _ref3[0],
      allocationConfigurations = _ref3[1],
      costCenters = _ref3[2],
      catalogs = _ref3[3];
    var _a, _b;
    setAllocation(allocation);
    setParts((_a = allocation === null || allocation === void 0 ? void 0 : allocation.parts) !== null && _a !== void 0 ? _a : []);
    setAllocationConfigurationsOptions(allocationConfigurations.items.map(function (el) {
      return {
        value: el.id,
        label: el.name
      };
    }));
    var usedPercentage = (_b = allocation === null || allocation === void 0 ? void 0 : allocation.parts.map(function (el) {
      return el.percentage;
    }).reduce(function (a, b) {
      return a + b;
    })) !== null && _b !== void 0 ? _b : 0;
    setCurrentPercentage(usedPercentage);
    setAllocationConfigurations(allocationConfigurations.items);
    setCostCenters(costCenters.items);
    setCatalogs(catalogs.items);
  };
  var onChangedAllocationConfiguration = function onChangedAllocationConfiguration(name, value) {
    var allocationConfiguration = allocationConfigurations.find(function (el) {
      return el.id === value;
    });
    setAllocationConfiguration(allocationConfiguration);
  };
  var submitPromise = function submitPromise() {
    var request = Object.assign(Object.assign({}, bind()), {
      parts: parts,
      mine: mine
    });
    if (allocationId) {
      return (0, _api.updateAllocation)(tenantId, allocationId, request, {
        access: access
      });
    }
    return (0, _api.createAllocation)(tenantId, request, {
      access: access
    });
  };
  var onSubmit = function onSubmit(event) {
    event.preventDefault();
    if (!isValid()) {
      return;
    }
    feedbackContext.showBackdrop();
    submitPromise().then(function (allocation) {
      feedbackContext.showSuccess((0, _core.translate)("allocations.".concat(allocationId ? 'edited' : 'created'), allocation));
      setPristine();
      history.goBack();
    })["catch"](feedbackContext.showError)["finally"](feedbackContext.closeBackdrop);
  };
  var onAddPart = (0, _react.useCallback)(function () {
    setPart(undefined);
    setIndex(-1);
    setPopup(true);
  }, []);
  var onEditPart = (0, _react.useCallback)(function (part, index) {
    setPart(part);
    setIndex(index);
    setPopup(true);
  }, []);
  var onDeletePart = (0, _react.useCallback)(function (index) {
    var newParts = parts.filter(function (el, i) {
      return i !== index;
    });
    setCurrentPercentage(newParts.map(function (el) {
      return +el.percentage;
    }).reduce(function (a, b) {
      return a + b;
    }, 0));
    setParts(newParts);
  }, [parts]);
  var onUpdated = function onUpdated(part) {
    onClose();
    var found = parts.find(function (el) {
      var ex = el.percentage,
        elx = __rest(el, ["percentage"]);
      var px = part.percentage,
        partx = __rest(part, ["percentage"]);
      return (0, _deepEqual["default"])(elx, partx, {
        strict: true
      });
    });
    if (found) {
      var costCenter = costCenters.find(function (el) {
        return el.id === found.cost_center_id;
      });
      if (costCenter) {
        feedbackContext.showWarning((0, _core.translate)('allocations.duplicated_cost_center', costCenter));
        return;
      } else if (index < 0) {
        feedbackContext.showWarning((0, _core.translate)('allocations.duplicated'));
        return;
      }
    }
    var newParts;
    if (index < 0) {
      newParts = [].concat(_toConsumableArray(parts), [part]);
    } else {
      newParts = parts.map(function (el, i) {
        if (i === index) {
          return part;
        }
        return el;
      });
    }
    setCurrentPercentage(newParts.map(function (el) {
      return +el.percentage;
    }).reduce(function (a, b) {
      return a + b;
    }));
    setParts(newParts);
  };
  var onClose = function onClose() {
    setPart(undefined);
    setIndex(-1);
    setPopup(false);
  };
  var columns = (0, _react.useMemo)(function () {
    var _a;
    var columns = (allocationConfiguration === null || allocationConfiguration === void 0 ? void 0 : allocationConfiguration.require_cost_center) ? [{
      title: (0, _core.translate)('cost_centers.single'),
      converter: function converter(item, indexCol, indexRow) {
        var _a, _b;
        return (_b = (_a = costCenters.find(function (costCenter) {
          return costCenter.id === item.cost_center_id;
        })) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : item.cost_center_id;
      },
      id: 'cost_center'
    }] : [];
    var dynamicColumns = (_a = allocationConfiguration === null || allocationConfiguration === void 0 ? void 0 : allocationConfiguration.catalogs.map(function (acCatalog) {
      var _a;
      var catalog = catalogs.find(function (el) {
        return el.id === acCatalog.catalog_id;
      });
      return {
        title: (_a = catalog === null || catalog === void 0 ? void 0 : catalog.name) !== null && _a !== void 0 ? _a : acCatalog.catalog_id,
        converter: function converter(item, indexCol, indexRow) {
          var _a, _b, _c;
          var currentCatalog = item.catalogs[acCatalog.catalog_id];
          return (_c = (_b = (_a = catalog === null || catalog === void 0 ? void 0 : catalog.values.find(function (value) {
            return value.external_id === currentCatalog;
          })) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : currentCatalog) !== null && _c !== void 0 ? _c : '---';
        },
        id: acCatalog.catalog_id
      };
    })) !== null && _a !== void 0 ? _a : [];
    var actionColumn = [{
      title: (0, _core.translate)('allocations.percentage'),
      converter: function converter(item, indexCol, indexRow) {
        return "".concat(item.percentage.toFixed(2), "%");
      },
      id: 'percentage'
    }, {
      title: /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
        color: "primary",
        size: "small",
        onClick: onAddPart,
        disabled: disabled || !allocationConfiguration || currentPercentage >= 100
      }, /*#__PURE__*/_react["default"].createElement(_commons.AddIcon, null)),
      converter: function converter(item, indexCol, indexRow) {
        return /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
          color: "error",
          size: "small",
          onClick: function onClick() {
            return onDeletePart(indexRow);
          },
          disabled: !!allocationId
        }, /*#__PURE__*/_react["default"].createElement(_commons.DeleteIcon, null));
      },
      id: 'actions',
      fixed: 'right',
      width: 60,
      textAlign: 'center'
    }];
    return [].concat(columns, _toConsumableArray(dynamicColumns), actionColumn);
  }, [allocationId, allocationConfiguration, catalogs, costCenters, currentPercentage, disabled, onAddPart, onDeletePart]);
  return /*#__PURE__*/_react["default"].createElement(_commons.Retrievable, {
    getPromise: fetchData,
    setData: setData,
    builder: function builder() {
      var _a, _b, _c;
      return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        container: true,
        justifyContent: "center",
        alignItems: "center"
      }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 12,
        md: 10,
        lg: 8,
        xl: 6
      }, /*#__PURE__*/_react["default"].createElement(_commons.Surface, {
        title: (0, _core.translate)(allocationId ? 'allocations.edit' : 'allocations.new'),
        subtitle: (_a = allocationConfigurationsOptions.find(function (el) {
          return !!allocationConfigurationId && el.value === allocationConfigurationId;
        })) === null || _a === void 0 ? void 0 : _a.label,
        icon: /*#__PURE__*/_react["default"].createElement(_commons.AllocationsIcon, null)
      }, /*#__PURE__*/_react["default"].createElement("form", {
        autoComplete: "off",
        noValidate: true,
        onSubmit: onSubmit
      }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        container: true,
        justifyContent: "space-between",
        alignItems: "center"
      }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_commons.AnyInput, {
        type: "text",
        name: "name",
        initialValue: allocation === null || allocation === void 0 ? void 0 : allocation.name,
        label: (0, _core.translate)('allocations.name'),
        required: true,
        validators: nameValidators,
        maxLength: 255,
        disabled: disabled,
        register: register,
        notifier: hasChangedName
      })), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_commons.AnyInput, {
        type: "text",
        name: "id",
        initialValue: initialId,
        label: (0, _core.translate)('allocations.id'),
        required: true,
        maxLength: 100,
        disabled: !!allocationId,
        register: register,
        validators: validators
      })), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_commons.AnyAutocomplete, {
        name: "allocation_configuration_id",
        label: (0, _core.translate)('allocation_configurations.single'),
        initialValue: (_c = (_b = allocation === null || allocation === void 0 ? void 0 : allocation.allocation_configuration_id) !== null && _b !== void 0 ? _b : allocationConfigurationId) !== null && _c !== void 0 ? _c : undefined,
        options: allocationConfigurationsOptions,
        required: true,
        disabled: disabled || !!allocationConfigurationId || !!allocationId || parts.length > 0,
        register: register,
        notifier: onChangedAllocationConfiguration,
        prefillWhenSingle: !disabled
      })), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 12,
        sx: {
          mt: 2
        }
      }, /*#__PURE__*/_react["default"].createElement(_material.Card, {
        variant: "outlined",
        sx: currentPercentage < 100 ? {
          mb: 2
        } : undefined
      }, /*#__PURE__*/_react["default"].createElement(_commons.DataGrid, {
        items: parts,
        empty: (0, _core.translate)('allocations.empty_parts'),
        loading: false,
        getId: function getId(item) {
          return JSON.stringify(item);
        },
        hoverable: false,
        noBorderLastRow: true,
        clickable: {
          onClick: onEditPart
        },
        columns: columns
      })), currentPercentage < 100 && parts.length > 0 && /*#__PURE__*/_react["default"].createElement(_commons.Alert, {
        variant: "warning",
        title: (0, _core.translate)('allocations.not_100', {
          percentage: currentPercentage
        }),
        plain: true
      })), /*#__PURE__*/_react["default"].createElement(_commons.FormActions, {
        id: allocationId,
        disabled: disabled || currentPercentage < 100
      })), /*#__PURE__*/_react["default"].createElement(_commons.FormPrompt, {
        isDirty: isDirty
      }))))), popup && allocationConfiguration && /*#__PURE__*/_react["default"].createElement(_AllocationPartForm["default"], {
        allocation: allocation,
        current: part,
        allocationConfiguration: allocationConfiguration,
        maxPercentage: 100 - currentPercentage,
        catalogs: catalogs,
        costCenters: costCenters,
        disabled: disabled,
        onUpdated: onUpdated,
        onClose: onClose
      }));
    }
  });
}